import { debounce } from "lodash";
import React from "react";
import { Label, Loader } from "semantic-ui-react";

import { type Filters } from "utils/queryUtils";
import enrollmentRulesUtils from "../../../../../utils/enrollmentRulesUtils";
import { type GetGroupEnrollmentUsersPreviewRequest, type UserInfo } from "../../../types";
import GroupUsersList from "../../AddGroup/GroupUsers/GroupUsersList/GroupUsersList";
import EnrollmentBuilder from "../EnrollmentBuilder/EnrollmentBuilder";

import { getDataSourceOptions } from "../EnrollmentBuilder/options";
import "./automaticallyDetect.scss";
import { type EnrollmentRule } from "./models";

const debounceTimeout = 1000;
const defaultCosmosRuleEnginePreviewTop = 50;

export interface AutomaticallyDetectPropTypes {
  values: { enrollmentRules: EnrollmentRule[] };
  validatedFieldProps: any;
  users: UserInfo[];
  usersCount: number;
  isLoading: boolean;
  loadUsers: (skip: number, top: number, orderParams: any, filterParams: any) => void;
  fetchGroupEnrollmentUsers: (request: GetGroupEnrollmentUsersPreviewRequest) => void;
  loadGroupEnrollmentPreview?: (top: number, rules: EnrollmentRule[]) => void;
  gridFilter: Filters;
  setGridFilter: (filter: Filters) => void;
  resetEnrollmentUsers: () => void;
  onIsValidChange?: (isValid: boolean) => void;
  disabled?: boolean;
  deepLink?: boolean;
  hidePeople?: boolean;
  showFullList?: boolean;
  groupUsersListComponent?: React.ReactNode;
}

export class AutomaticallyDetect extends React.Component<AutomaticallyDetectPropTypes> {
  componentWillUnmount() {
    const { resetEnrollmentUsers } = this.props;
    resetEnrollmentUsers && resetEnrollmentUsers();
  }

  loadPage = () => {
    const {
      validatedFieldProps,
      values: { enrollmentRules },
    } = this.props;

    if (enrollmentRules.some((x: any) => !x.value)) {
      return;
    }

    if (!validatedFieldProps.isFormValid || !enrollmentRulesUtils.validateEnrollmentRules(enrollmentRules)) {
      return;
    }

    const { fetchGroupEnrollmentUsers } = this.props;
    fetchGroupEnrollmentUsers({
      top: defaultCosmosRuleEnginePreviewTop,
      rules: enrollmentRulesUtils.mapRulesToSeverFormat(enrollmentRules),
    });
  };

  /* istanbul ignore next */
  debouncedChangeEnrollmentFilter = debounce(() => {
    const {
      values: { enrollmentRules },
      setGridFilter,
    } = this.props;
    setGridFilter(enrollmentRules);
  }, debounceTimeout);

  handleRuleChange = (i: number) => {
    const {
      values: { enrollmentRules },
    } = this.props;
    if (enrollmentRules[i].value) {
      this.debouncedChangeEnrollmentFilter();
    }
  };

  /* istanbul ignore next */
  renderPeopleLabelBadge = () => {
    const { isLoading, usersCount } = this.props;
    return (
      <Label circular color="blue" size="medium">
        {isLoading ? <Loader active size="mini" inline="centered" /> : usersCount.toLocaleString()}
      </Label>
    );
  };

  render() {
    const { validatedFieldProps, disabled, onIsValidChange, hidePeople, showFullList, groupUsersListComponent } =
      this.props;

    return (
      <section className="automatically-detect">
        <EnrollmentBuilder
          values={{ ...this.props.values }}
          disabled={!!disabled}
          onChange={this.debouncedChangeEnrollmentFilter}
          validatedFieldProps={validatedFieldProps}
          handleCriteriaChange={this.handleRuleChange}
          onIsValidChange={onIsValidChange}
          dataSourceOptions={getDataSourceOptions(true)}
        />
        {!hidePeople && (
          <>
            <div className="people-label">
              PEOPLE
              {this.renderPeopleLabelBadge()}
            </div>
            <div className="enrollment-rules-list-container">
              {showFullList && groupUsersListComponent ? (
                groupUsersListComponent
              ) : (
                <GroupUsersList
                  isGroupCreation={false}
                  isAutoEnrollment
                  filter={this.props.gridFilter}
                  users={this.props.users}
                  usersCount={this.props.usersCount}
                  isLoading={this.props.isLoading}
                  loadPage={this.loadPage}
                  renderHeaderSection={false}
                  deepLink={this.props.deepLink}
                />
              )}
            </div>
          </>
        )}
      </section>
    );
  }
}

export default AutomaticallyDetect;
